import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Table } from '@fikasio/react-ui-components';
import { OpenStatusDropdownProvider } from 'components/tasks/TasksViewer/TaskStatusDropdown';
import EmptyTableRow from 'components/UI/EmptyTableRow';
import { RangeSelectEvent } from 'utils/rangeSelection';
import ObjectiveRow from './ObjectiveRow';
import { sortObjectivesByDueDate } from './utils';
import styles from './ObjectivesList.module.css';

const ObjectivesList = ({
  objectives,
  onAddObjective,
  onObjectiveClick,
  onObjectiveSelect,
  onSelectAllObjectives,
  projectId,
  selectedObjectives,
}) => {
  const { t } = useTranslation();

  const objectivesToShow = sortObjectivesByDueDate(objectives);
  const allObjectivesAreChecked = !!objectives?.length
    && (objectives?.length === selectedObjectives.length);

  const addObjective = async objective => {
    onAddObjective(objective)
      .then(async ({ data: resultObjective }) => {
        if (resultObjective) {
          await new Promise(resolve => setTimeout(resolve, 200));
          const elementsWithClassname = document.getElementsByClassName(resultObjective.id);
          const nbElementsWithClassname = elementsWithClassname.length;
          if (nbElementsWithClassname) {
            (elementsWithClassname[nbElementsWithClassname - 1] as HTMLElement).focus();
          }
        }
      });
  };

  return (
    <div className={styles.objectivesList}>
      <OpenStatusDropdownProvider>
      <Table
        bordered
        hover
        responsive
      >
      <thead>
        <tr>
          <th style={{ width: 35 }}>
            <Checkbox
              isChecked={allObjectivesAreChecked}
              onClick={() => {
                if (allObjectivesAreChecked) {
                  onSelectAllObjectives([]);
                } else {
                  onSelectAllObjectives(objectivesToShow);
                }
              }}
            />
          </th>
          <th style={{ width: 35 }} />
          <th />
          <th style={{ width: 160 }} />
          <th style={{ width: 140 }} />
          <th style={{ width: 110 }} />
          <th style={{ width: 35 }} />
          <th style={{ width: 35 }} />
        </tr>
      </thead>
      <tbody>
        {
          (!objectives || !objectives.length) && (
            <EmptyTableRow
              colSpan={8}
              message={t('noObjectivesToDisplay')}
            />
          )
        }
        {
          objectivesToShow.map(objective => (
            <ObjectiveRow
              isSelected={!!selectedObjectives.find(o => objective.id === o.id)}
              key={objective.id}
              objective={objective}
              onAddObjective={addObjective}
              onClick={onObjectiveClick}
              onSelect={(selectedObjective, event?: RangeSelectEvent) => onObjectiveSelect(
                selectedObjective,
                event,
                objectivesToShow,
              )}
              projectId={projectId}
            />
          ))
        }
      </tbody>
      </Table>
      </OpenStatusDropdownProvider>
    </div>
  );
};

export default ObjectivesList;
